import { render, staticRenderFns } from "./NewHome.vue?vue&type=template&id=25fff0d3&scoped=true"
import script from "./NewHome.vue?vue&type=script&lang=js"
export * from "./NewHome.vue?vue&type=script&lang=js"
import style0 from "./NewHome.vue?vue&type=style&index=0&id=25fff0d3&prod&lang=less&scoped=true"
import style1 from "./NewHome.vue?vue&type=style&index=1&id=25fff0d3&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fff0d3",
  null
  
)

export default component.exports